import { useIntl } from 'react-intl';
import { SchemaFieldIconType } from '@rossum/components/schema-field-icon/SchemaFieldIcon';
import { IconCloudDataConnection } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Tooltip, Typography } from '@rossum/ui/material';
import { CellIcons } from './CellIcons';

type HeaderCellProps = {
  iconType?: SchemaFieldIconType | null;
  primaryText: string | undefined;
  secondaryText: string | undefined;
  usedContextFields?: string[];
};

const HeaderCell = ({
  secondaryText,
  iconType,
  primaryText,
  usedContextFields,
}: HeaderCellProps) => {
  const intl = useIntl();

  return (
    <Stack spacing={1} direction="row" component="span">
      <Stack>
        <Typography variant="body2">{primaryText ?? ''}</Typography>
        <Typography variant="caption" color="text.secondary">
          {secondaryText ?? ''}
        </Typography>
      </Stack>
      {iconType ? <CellIcons type={iconType} /> : null}
      {usedContextFields && usedContextFields.length > 0 ? (
        <Tooltip
          title={intl.formatMessage(
            {
              id: 'features.queueSettings.fields.formulaPreview.table.usedContextFields',
            },
            { fields: usedContextFields.join(', ') }
          )}
        >
          <SvgIcon fontSize="medium" sx={{ color: 'text.secondary' }}>
            <IconCloudDataConnection />
          </SvgIcon>
        </Tooltip>
      ) : null}
    </Stack>
  );
};

export { HeaderCell };
